/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Exercise_Sheet_Set_RepsInputs */

const en_us2_exercise_sheet_set_reps = /** @type {(inputs: Exercise_Sheet_Set_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 rep`);
	return /** @type {LocalizedString} */ (`${i?.count} reps`)
	
};

const pt_br2_exercise_sheet_set_reps = /** @type {(inputs: Exercise_Sheet_Set_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 repetição`);
	return /** @type {LocalizedString} */ (`${i?.count} repetições`)
	
};

const es_419_exercise_sheet_set_reps = /** @type {(inputs: Exercise_Sheet_Set_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 rep`);
	return /** @type {LocalizedString} */ (`${i?.count} reps`)
	
};

const pt_pt2_exercise_sheet_set_reps = /** @type {(inputs: Exercise_Sheet_Set_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 repetição`);
	return /** @type {LocalizedString} */ (`${i?.count} repetições`)
	
};

const fr_fr2_exercise_sheet_set_reps = /** @type {(inputs: Exercise_Sheet_Set_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 rép.`);
	return /** @type {LocalizedString} */ (`${i?.count} rép.`)
	
};

const de_de2_exercise_sheet_set_reps = /** @type {(inputs: Exercise_Sheet_Set_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Wdh.`);
	return /** @type {LocalizedString} */ (`${i?.count} Wdh.`)
	
};

const it_it2_exercise_sheet_set_reps = /** @type {(inputs: Exercise_Sheet_Set_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 rip.`);
	return /** @type {LocalizedString} */ (`${i?.count} rip.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 rep" |
* | * | "{count} reps" |
*
* @param {Exercise_Sheet_Set_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_set_reps = /** @type {((inputs: Exercise_Sheet_Set_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Set_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_set_reps(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_set_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_set_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_set_reps(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_set_reps(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_set_reps(inputs)
	return en_us2_exercise_sheet_set_reps(inputs)
});
export { exercise_sheet_set_reps as "exercise-sheet.set_reps" }